import Glide from '@glidejs/glide'


/**
 * @see https://glidejs.com/docs/options/
 */
const setupSlideshows = () =>
{
	const glideContainers = document.querySelectorAll( '.glide' );

	glideContainers.forEach( glideContainer =>
	{
		const autoplayAttr = glideContainer.dataset.autoplay;
		let autoplay       = false;

		if (autoplayAttr !== undefined && autoplayAttr !== 'false') {
			autoplay = autoplayAttr === '' ? 3000 : parseInt( autoplayAttr, 10 )
		}

		new Glide( glideContainer, {
			type:     'carousel',
			perView:  1,
			autoplay: autoplay,
		} ).mount();
	} );
};


export default setupSlideshows;